// A passenger's feet relative to the sole Reception platform (metres).
export function validElevatorPassenger(value) {
  return Array.isArray(value) && value.length === 3 && value.every(Number.isFinite) &&
    Math.hypot(value[0], value[2]) <= 2.3 && value[1] >= -0.2 && value[1] <= 0.7
}

export function elevatorPassengerWorld(relative, platform) {
  return [relative[0] + platform.x, relative[1] + platform.y, relative[2] + platform.z]
}
